<template>
  <div class="sidebar">
    <p class="title">{{ content.title }}</p>
    <div class="content">
      <div class="second-level" v-for="(item, index) in content.sub" :key="index">
        <div :class="{'selected': index === selectedIdx}">
          <p class="second-title" @click="clickTitle(index)">{{ item.title }}</p>
        </div>
        <div class="third-level" v-if="item.sub.length" :class="{'sub-selected-bg': index === selectedIdx}">
          <p class="third-title" :class="{'sub-selected': (subIndex === subSelectIdx) && (index === selectedIdx)}" v-for="(subItem, subIndex) in item.sub" :key="subIndex" @click="clickSubTitle(index, subIndex, subItem)">{{ subItem.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  props: {
    // {title: '', sub: [{title: '', url: '', sub: [{title: '', url: ''}, ...]}, ...]}
    content: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      selectedIdx: 0,
      subSelectIdx: -1,
    };
  },
  watch: {
    $route: "changeRoute",
    // 手动指定高亮项，用于文章页
    '$store.state.highlightText': "setHighlightText"
  },
  methods: {
    clickTitle(index) {
      this.selectedIdx = index;
      if (this.content.sub[index].sub.length) this.subSelectIdx = 0;
      else this.subSelectIdx = -1;
      this.$router.push({ path: `${this.content.sub[index].url}` });
    },
    clickSubTitle(index, subIndex, array) {
      this.subSelectIdx = subIndex;
      this.selectedIdx = index;
      this.$router.push({ path: `${array.url}` });
    },
    changeRoute(newVal) {
      // 选择三级菜单时不变化二级菜单高亮
      if (this.subSelectIdx === -1) {
        this.selectedIdx = this.content.sub.findIndex(
          item => newVal.path === item.url
        );
      }
    },
    setHighlightText(text) {
      // 若text为空，则当前不在文章页，高亮情况由路由决定
      if (text) {
        this.content.sub.forEach((item, index) => {
          if (item.title === text) {
            this.selectedIdx = index
          } else if (item.sub.length) {
            item.sub.forEach((subItem, subIndex) => {
              if (subItem.title === text) {
                this.selectedIdx = index
                this.subSelectIdx = subIndex
              }
            })
          }
        })
      }
    }
  },
  created() {
    this.selectedIdx = this.content.sub.findIndex(
      item => this.$route.path === item.url
    );
    if (this.selectedIdx === -1) {
      // 当前选中三级菜单,未在二级菜单中找到当前url
      this.selectedIdx = this.content.sub.findIndex(
        item =>
          (this.subSelectIdx = item.sub.findIndex(
            subItem => subItem.url === this.$route.path
          )) !== -1
      );
    } else {
      // 解决二级菜单与三级菜单第一个同url的问题
      this.subSelectIdx = this.content.sub[this.selectedIdx].sub.findIndex(
        item => this.$route.path === item.url
      );
    }
    // 高亮指定菜单项。同时watch也必须要有，对应直接访问、刷新页面两种情况
    this.setHighlightText(this.$store.state.highlightText)
  }
};
</script>

<style scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  width: 272px;
  /* ??flex?????? */
  height: 100%;
  background: #0087d3;
  border-radius: 3px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
}
.title {
  margin-left: 30px;
  font-size: 32px;
  color: #fff;
  line-height: 96px;
}
.content {
  align-self: flex-end;
  width: 90%;
  height: calc(100% - 96px);
  padding-bottom: 100px;
  background: #fff;
}
.second-level {
}
.second-title {
  margin: 15px 0;
  padding: 0 20px;
  line-height: 45px;
  font-size: 24px;
  cursor: pointer;
}
.third-level {
  margin-top: -15px;
  padding: 5px 0;
}
.third-title {
  margin: 15px 40px;
  font-size: 18px;
  color: #777;
  cursor: pointer;
}
.selected {
  position: relative;
  background: #3a9fda;
  color: #fff;
}
.selected::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -3px;
  height: 50px;
  width: 3px;
  background: #ffbb44;
}
.sub-selected {
  color: #0087d3;
}
.sub-selected-bg {
  background: #f4f4f4;
}
</style>